import { useMemo } from 'react';
import { useUserState } from '../query/UserProvider';
import { extractFollowedRolesFromUserState, type FollowedRole } from '../utils/user-state/extract-followed-roles-from-user-state';

/**
 * TEC-404: reads the TanStack `userState` cache instead of Redux — its writer,
 * `useRoleFollowActions.ts`, was migrated in the same pass, so the cache this reads is always
 * populated by the write path (both guest-persisted and signed-in cases).
 */
export function useFollowedRoles(): FollowedRole[] {
  const { data } = useUserState();
  return useMemo(() => extractFollowedRolesFromUserState(data ?? {}), [data]);
}
